import { Helmet } from 'react-helmet-async';
import { Navigate, useParams } from 'react-router';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import KitchenDispatchOrderDetailView from 'src/sections/kitchen-dispatches/view/kitchen-dispatch-order-detail-view';

export default function KitchenDispatchOrderDetailPage() {
  const params = useParams();
  const { user: authUser } = useAuthContext();

  const { id } = params;

  return (
    <>
      <Helmet>
        <title> Kitchen dispatch order details</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.READ_KITCHEN_INVENTORY_TRANSACTION,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <KitchenDispatchOrderDetailView id={`${id}`} />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
